// extracted by mini-css-extract-plugin
export default {"tabBar":"k8P7IgIz","tab":"yZonUGJ9","icon":"Ux3cW6wG","label":"dyPAtYTG"};